import React from "react";

export default function AWS_Elastic_Beanstalk() {
  return (
    <div>
      <h1>What is Elastic Beanstalk</h1>
      <p>
        Route: <code>/aws/elastic-beanstalk</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
